<template>
  <section class="login">
    <Logo></Logo>
    <h1>
      <span class="hubday-green" @click="result = 'test'">h</span>ub
      <span class="hubday-green">d</span>ay
    </h1>
    <transition name="fade" mode="out-in">
      <h2 v-bind:key="result">{{ result }}</h2>
    </transition>
  </section>
</template>

<style scoped>
.login {
  min-height: 100%;
  height: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #222;
  color: white;
}

.login h1 {
  display: flex;
  align-items: center;
  font-size: 80px;
  font-weight: bold;
  font-family: "Poiret One";
  margin: -20px 0 0 0;
}

.login h1 .hubday-green {
  color: #afdab9;
}

.login h2 {
  font-family: "Lato";
  padding: 0 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<script>
import axios from "axios";
import Logo from "@/components/Logo";

export default {
  components: {
    Logo,
  },
  data() {
    return {
      result: "Veuillez patienter...",
    };
  },
  methods: {
    getCustomToken() {
      if (
        this.$route.query.code !== null &&
        this.$route.query.code !== undefined &&
        this.$route.query.code != ""
      ) {
        var code = this.$route.query.code;
        var state = this.$route.query.state;

        axios
          .get(
            "https://www.hubday.fr/auth/api/login?mode=gitlab&code=" +
            code +
            "&state=" +
            state
          )
          .then((response) => {
            var jsonResult = response["data"];
            if (jsonResult["status"] == "error") {
              this.result = "Erreur : " + jsonResult["message"];
            } else {
              this.result =
                "Bienvenue " +
                jsonResult["displayName"] +
                ", nous vous connectons...";
              this.login(jsonResult["token"]);
            }
          });
      } else {
        this.result = "Un code gitlab est nécessaire !";
      }
    },
    login(token) {
      this.$store.dispatch("loginWithCustomToken", token)
    },
  },
  props: {
    code: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.getCustomToken();
  },
};
</script>